var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBoxClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1",
    d: "M5.33398 12.8229C5.33398 12.0054 5.33398 11.5966 5.48623 11.2291C5.63847 10.8615 5.9275 10.5725 6.50556 9.99444L8.16241 8.33759C8.74047 7.75953 9.0295 7.4705 9.39704 7.31826C9.76459 7.16602 10.1733 7.16602 10.9908 7.16602H21.0105C21.828 7.16602 22.2367 7.16602 22.6043 7.31826C22.9718 7.4705 23.2608 7.75953 23.8389 8.33759L25.4957 9.99444C26.0738 10.5725 26.3628 10.8615 26.5151 11.2291C26.6673 11.5966 26.6673 12.0054 26.6673 12.8229V21.166C26.6673 23.9944 26.6673 25.4087 25.7886 26.2873C24.91 27.166 23.4957 27.166 20.6673 27.166H11.334C8.50556 27.166 7.09134 27.166 6.21266 26.2873C5.33398 25.4087 5.33398 23.9944 5.33398 21.166V12.8229Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M5.33398 13.834H26.6673",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    d: "M18.4436 7.16602L13.5547 7.16602C13.2404 7.16602 11.75 12.4993 11.6523 12.597C11.5547 12.6946 11.5547 12.8517 11.5547 13.166L11.5547 18.7216C11.5547 19.7413 11.5547 20.2512 11.6866 20.5252C11.981 21.137 12.688 21.4299 13.3287 21.2055C13.6158 21.1049 13.9763 20.7444 14.6974 20.0233C15.0314 19.6894 15.1983 19.5224 15.3759 19.4285C15.7658 19.2223 16.2325 19.2223 16.6224 19.4285C16.7999 19.5224 16.9669 19.6894 17.3009 20.0233C18.022 20.7444 18.3825 21.1049 18.6695 21.2055C19.3103 21.4299 20.0173 21.137 20.3117 20.5252C20.4436 20.2512 20.4436 19.7413 20.4436 18.7216V13.166C20.4436 12.8517 20.4436 12.6946 20.3459 12.597C20.2483 12.4993 18.7578 7.16602 18.4436 7.16602Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxClose);
export default __webpack_public_path__ + "static/media/IconBoxClose.f41a103a4ad1c52805d43a427c941468.svg";
export { ForwardRef as ReactComponent };